// Campus photo for /colleges/fairfield-university: CC BY-SA 4.0, by Zeete, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABellarmine_Hall_at_Fairfield_University%2C_CT.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/fairfield-university/; credited under the photo.
const photo = {
    "slug": "fairfield-university",
    "alt": "The stone Tudor-style front of Bellarmine Hall at Fairfield University under a clear sky",
    "src": "/colleges/fairfield-university/campus-1600.webp",
    "srcSmall": "/colleges/fairfield-university/campus-800.webp",
    "srcMid": "/colleges/fairfield-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/fairfield-university/og.jpg",
    "title": "Bellarmine Hall at Fairfield University, CT",
    "author": "Zeete",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABellarmine_Hall_at_Fairfield_University%2C_CT.jpg",
    "read": "2026-10-01"
};

export default photo;
